import { LowerCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { lowerCase } from '@rxweb/reactive-forms';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root',
})
export class SecureInnerPagesGuard implements CanActivate {

  constructor(
    public authService: AuthService,
    public router: Router,
    public dataService: DataService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.getUser().pipe(
      take(1),
      switchMap(user => {
        if (user) {
          return this.authService.getUserData(user.uid);
        }
        return of(null);
      }),
      map((userData) => {
        // const ondernemingId: string = next.parent.params.ondernemingId;
        const ondernemingNaam: string = next.parent.params.ondernemingNaam;
        if (userData) {
          if (ondernemingNaam.toLowerCase() !== userData.adminVan.toLowerCase()  && !userData.isAdmin) {
            this.authService.SignOut();
            this.router.navigate(['/', ondernemingNaam, 'tools']);
            return false;
          }
        }
        return true;
      }),
    );
  }
}
